import { useState } from 'react';
import { useProjects, useDeleteProject } from '../hooks/useProjects';
import { ProjectList } from '../components/dashboard/ProjectList';
import { EmptyState } from '../components/dashboard/EmptyState';
import { CreateProjectModal } from '../components/dashboard/CreateProjectModal';
import { LoadingSpinner } from '../components/common/LoadingSpinner';
import { Button } from '../components/common/Button';
import { useTranslation } from 'react-i18next';

export function DashboardPage() {
  const { t } = useTranslation('dashboard');

  const { data: projects, isLoading, error } = useProjects();
  const deleteProject = useDeleteProject();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const handleDelete = async (projectId: string) => {
    try {
      await deleteProject.mutateAsync(projectId);
    } catch (error) {
      console.error('Failed to delete project:', error);
      alert('Failed to delete project');
    }
  };

  if (isLoading) {
    return (
      <div className="container mx-auto px-6 py-8 flex justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto px-6 py-8">
        <div className="bg-red-50 border border-red-200/60 rounded-lg p-4 text-red-700">
          <p className="text-sm font-medium">Error loading projects: {error.message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-6 py-8">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-headline mb-2">{t('dashboard:title')}</h1>
          <p className="text-body">{t('dashboard:subtitle')}</p>
        </div>
        {projects && projects.length > 0 && (
          <Button onClick={() => setIsCreateModalOpen(true)}>{t('dashboard:newProject')}</Button>
        )}
      </div>

      {projects && projects.length === 0 ? (
        <EmptyState onCreateProject={() => setIsCreateModalOpen(true)} />
      ) : (
        <ProjectList projects={projects || []} onDelete={handleDelete} />
      )}

      <CreateProjectModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
      />
    </div>
  );
}
